import { render, staticRenderFns } from "./ForumWidget.vue?vue&type=template&id=96d844c2&scoped=true"
import script from "./ForumWidget.vue?vue&type=script&lang=js"
export * from "./ForumWidget.vue?vue&type=script&lang=js"
import style0 from "./ForumWidget.vue?vue&type=style&index=0&id=96d844c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d844c2",
  null
  
)

export default component.exports